import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from "@angular/forms";
import {FilterFieldStringComponent} from "@app/_modules/filter-fields/types/string/filter-field-string.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  declarations: [
    FilterFieldStringComponent
  ],
  exports: [
    FilterFieldStringComponent
  ]
})
export class FilterFieldStringModule {}
